import { colors } from '../../colors'

const UserIcon: React.FC = () => {
  const containerStyles: React.CSSProperties = {
    marginRight: '4px',
  }

  const iconStyle: React.CSSProperties = {
    color: colors['text-secondary'],
    fontSize: '14px',
  }

  return (
    <div style={containerStyles}>
      <span style={iconStyle} className="icon_font icf_user" />
    </div>
  )
}

export default UserIcon
